"use strict";
// import functions
import FilterCaseStudiesArchive from "./modules/filter_case_studies_archive";
import FocusAccessibility from "./modules/focus_accessibility";
import GlobalNavigation from "./modules/global_navigation";
import HandleCookieNoticeAndGoogleAnalytics from "./modules/cookie_notice_and_google_analytics";
import IssuesVisibility from "./modules/issues_visibility";
import TypeRatioInterpolation from "./modules/type_ratio_interpolation";
import LanguageSwitchVisibility from "./modules/language_switch_visibility";
// wait for the DOM to load
window.addEventListener("load", function () {
    /*
        interpolate between type ratio minimum and maximum values,
        and store the result in a CSS custom property
    */
    TypeRatioInterpolation();
    /*
        allow enchanced focus detection (depends on a11y.js)
    */
    FocusAccessibility();
    /*
        provide an accessible global navigation
    */
    GlobalNavigation();
    /*
        handle user's decision on storing cookies,
        load Google Analytics if user accepts
    */
    HandleCookieNoticeAndGoogleAnalytics();
    /*
        handle toggling visibility of global header language switch,
        when user interacts with the relevant button
    */
    LanguageSwitchVisibility();
    /*
        handle toggling visibility of single issues sibling posts,
        when user interacts with the relevant button
    */
    IssuesVisibility();
    /*
        construct a URL when user interacts with the Case Studies archive
        filter form
    */
    FilterCaseStudiesArchive();
});
